import { Component, Prop, Vue } from 'vue-property-decorator';
import jumpToVerifyCredit from '@/shared/verify-credit-controller';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';

import styles from './index.module.scss';

@Component
export default class IdentityExpiresBar extends Vue {
  @Prop(Boolean) readonly visible!: boolean;

  private handleUpdateIdentity() {
    this.$ubtPageButtonNew('finance_loan_identity_expires');
    jumpToVerifyCredit(VerifySceneEnum.UPDATE_EXPIRES_IDENTITY);
  }

  private mounted() {
    if (this.visible) {
      this.$ubtModuleExposeNew('finance_loan_identity_expires');
    }
  }

  private render() {
    if (this.visible) {
      return (
        <div class={styles.identityExpiresBar} onClick={() => this.handleUpdateIdentity()}>
          <p class={styles.remindIcon} />
          <p class={styles.remindText}>您的身份证即将过期，请更新身份证</p>
          <p class={styles.remindOperate}>去更新</p>
        </div>
      );
    }

    return null;
  }
}
